module.exports = __webpack_public_path__ + "static/orderDataDownloadImage-b2cd09268f5cdccedace48241bc7a60d.png";